import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { ContractTypeService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetContractTypesResolver implements Resolve<any> {

  constructor(private contractTypeService: ContractTypeService) { }

  resolve() {
    return this.contractTypeService.load();
  }
}
